import React from "react";
import {
    Dialog,
    DialogHeader,
    DialogContent,
    Inline,
    FormControl,
    Input,
    IconButton,
    Button,
    Banner,
  } from "@airbus/components-react";
  import {Visibility, VisibilityOff} from '@airbus/icons/react';
  import eventBus from "../eventBus/EventBus";

import GlobalUser from "../models/User";

 /*****
 * 
 * MODAL Box Component
 * From eventBus:
    eventBus.dispatch("changePassword", { message: {
               title: Titre,
               open: true / false (Modal visibility)
               user_id: id of the user
            } });
 */


  class ModalChangePassword extends React.Component {

    /*************/
    /*CONSTRUCTOR*/ 
    /*************/
    constructor(props) {
        super()

        //title
        this.title = null;

        //user id
        this.user_id = null;
        this.user = GlobalUser;
        

        //default visibility
        this.open = false;

        //States
        this.state={
            open: this.open,            //on true open modal box
            showPassword: false,        //password display
            notification: false,
            form: {
                password: '',
                confirmPassword: ''
            },
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
        }


        //Notifications properties
        this.notifVariant = null;
        this.notifMessage = null;
        this.notifDescription = null;


    }

    componentDidMount() {

        //Manage screen size
        window.addEventListener("resize", this.handleResize);

        //Listener MessageBox fired
        eventBus.on("changePassword", (data) => {          
            this.title=data['message'].title;
            this.user_id=data['message'].user_id;
            this.open=data['message'].open;
            this.setState({open: this.open})


        });
    }

    /*Handle screen size*/
    handleResize = (e) => {
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
        };


    /*************/
    /*RENDERING*/ 
    /*************/
    render(){
        return(
            <div>
                <Dialog className={"modalBox"} open={this.state.open} onClose={() => this.setState({open:false})} >
                    <DialogHeader>{this.title}</DialogHeader>
                
                    <DialogContent >

                            {/* Notification*/}
                            {this.state.notification ?
                                <div style={{position:"fixed", width:this.state.windowWidth-90, zIndex:1000}}>
                                <Banner style={{display:this.state.notification}} variant={this.notifVariant} autoHideDuration={3000}  onClose={() => this.toggleNotif(false)}>
                                    <div>
                                    <p>{this.notifMessage}</p>
                                    {this.notifDescription !== null ?
                                    <p>{this.notifDescription}</p>
                                    :null}
                                    </div>
                                </Banner>
                                <p></p>
                                </div>
                            :null}
                            
                            <Inline spacing="2-x" align="left" >
                                {/* Password */}

                                <FormControl
                                    error={!this.passwordValid()}
                                    errorText="Obligatoire"
                                    label="Nouveau Mot de Passe"
                                    placeholder="Mot de Passe"
                                    required
                                >
                                    <Input style={{width:'220px'}}
                                            value={this.state.form.password} 
                                            type={this.state.showPassword ? "text" : "password"}
                                            onChange={this.onChangePassword} 
                                            endAdornment={
                                                <IconButton variant="ghost" size="small" onClick={() => this.setState({showPassword:!this.state.showPassword})}>
                                                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            }
                                    />
                                </FormControl>
                            </Inline>
                            
                            {/* Confirm Password */}
                            <Inline spacing="2-x" align="left" >

                                <FormControl
                                    error={!this.passwordConfirmValid()}
                                    errorText="Les mots de passe ne sont pas identiques"
                                    label="Confirmer Mot de Passe"
                                    placeholder="Mot de Passe"
                                    required
                                >
                                    <Input  style={{width:'220px'}}
                                            value={this.state.form.confirmPassword} 
                                            type={this.state.showPassword ? "text" : "password"}
                                            onChange={this.onChangeConfirmPassword} 
                                            endAdornment={
                                                <IconButton variant="ghost" size="small" onClick={() => this.setState({showPassword:!this.state.showPassword})}>
                                                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            }
                                    />
                                </FormControl>
                            </Inline>
                        
                        
                        {/* Submit */}

                        <Button variant="primary" 
                                onClick = {this.onSubmit}
                                disabled = {!this.passwordConfirmValid() || !this.passwordValid()}
                                style={{
                                    width: "100%"
                                    }}>
                                MODFIER MON MOT DE PASSE
                        </Button>
                        
                    </DialogContent>
                
                </Dialog>
            </div>
        )}

    
    /**
    * FUNCTIONS
    */

    //Check Password
    passwordValid = () => {
        return this.state.form.password !== undefined && this.state.form.password.length > 0;
    };

    //Check Password
    passwordConfirmValid = () => {
        return this.state.form.password === this.state.form.confirmPassword;
    };

    //PASSWORD Input Change handler
    onChangePassword = (event) => {
         
        let formData = this.state.form;
        formData.password = event.target.value;
        
        this.setState({form:formData});
         
     }

     //PASSWORD Input Change handler
    onChangeConfirmPassword = (event) => {
         
        let formData = this.state.form;
        formData.confirmPassword = event.target.value;
        
        this.setState({form:formData});
         
     }

     /**
      * EVENTS
      */

     //Submit Login & Password
    onSubmit = async (event) =>  {

        let pwd = this.state.form.password;
        let user_id = this.user_id;

        let response  = await this.user.changePassword(user_id, pwd);
        //debugger;
        //API call error
        if (response === undefined){
            //Fire notification
            this.notifVariant = "error";
            this.notifMessage = "Call API erreur: Le mot de passe n'a pas pu être modifié";
            this.notifDescription = null;
            this.toggleNotif(true);
        }
        //Erreur modification de mot de passe?
        else if (response.response === "200"){           
            //Display success banner
            this.notifVariant = "success";
            this.notifMessage = "Le mot de passe a été modifié avec succès";
            this.notifDescription = null;
            this.toggleNotif(true)       
            

        }
        else{
            
            //API return <> 200
            this.notifVariant = 'error';
            this.notifMessage = 'Erreur lors de la modification du mot de passe.';
            this.notifDescription = response.response+": "+response.responseDescription;
            this.toggleNotif(true);


        }
        

    }

   //fire / close notification
   toggleNotif(val) {
    this.setState({
        notification: val
    });
  }

    
       

  }

  export default ModalChangePassword;
